import { render, staticRenderFns } from "./releasedtoday.vue?vue&type=template&id=a22b2238&scoped=true&"
import script from "./releasedtoday.vue?vue&type=script&lang=js&"
export * from "./releasedtoday.vue?vue&type=script&lang=js&"
import style0 from "./releasedtoday.vue?vue&type=style&index=0&id=a22b2238&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22b2238",
  null
  
)

export default component.exports